export const policies: string[] = [
  'Este sitio y sus servicios están dirigidos exclusivamente a personas mayores de edad.',
  'Las consultas y prácticas ofrecidas son de carácter espiritual y tradicional.',
  'Las consultas pueden ser sin costo cuando así se indique. Determinados rituales, materiales o servicios pueden tener un costo, el cual será informado antes de realizar cualquier pago.',
  'Los resultados de las prácticas no están garantizados y las experiencias pueden ser diferentes para cada persona.',
  'Estos servicios no sustituyen atención médica, psicológica, psiquiátrica, legal o financiera profesional.',
  'Los pagos, condiciones y políticas de reembolso deben informarse claramente antes de contratar un servicio.',
]
